module.exports = __webpack_public_path__ + "img/header_christmas.d86cc75.png";